import React from 'react';
import { AhaButton } from 'components/common/reactifyWebComponent';
import ReactiveContainer from './ReactiveContainer';

interface AhaCreateRecordMenuButtonProps {
  buttonText?: string;
  className?: string;
  scope: string;
  afterView: string;
  onSelect: (event: React.MouseEvent<HTMLElement>) => void;
  defaultName?: string;
  parentRecordType?: string;
  parentRecordId?: RecordId;
}

/**
 * A button that opens a menu to create a new record. Existential issue with the current reactive partial approach
 *   is that it renders a blank menu when the user cannot create any record types.
 *
 * So currently you should only use this in a place where you know the user can create records of some kinds.
 * Ideally yes, the button would only render itself once it knows there are going to be options available.
 */

const AhaCreateRecordMenuButton: React.FC<AhaCreateRecordMenuButtonProps> = ({
  buttonText = 'Create record',
  className = '',
  scope,
  afterView,
  onSelect,
  defaultName,
  parentRecordType,
  parentRecordId,
}) => {
  const params = new URLSearchParams({
    layout: 'aha-menu',
    scope: scope!,
    after_view: afterView!,
    skip_new: 'true',
  });

  if (defaultName) params.append('name', defaultName);
  if (parentRecordType) params.append('parent_record_type', parentRecordType);
  if (parentRecordId)
    params.append('parent_record_id', parentRecordId.toString());

  return (
    <aha-menu>
      <AhaButton slot='control' className={className}>
        {buttonText} <i className='fa-regular fa-plus tw-ml-1' />
      </AhaButton>
      <aha-menu-content onClick={onSelect}>
        <ReactiveContainer
          reactiveUrl={`/user/add_record_menu?${params.toString()}`}
          data-reactive-stubbed-content='true'
          data-reactive-load-immediately='true'
        />
      </aha-menu-content>
    </aha-menu>
  );
};

export default AhaCreateRecordMenuButton;
